<template>
  <div id="pc">
    <Pheader></Pheader>
    <DialogBs :visible.sync="showStart">
      <StartModal></StartModal>
    </DialogBs>
    <div class="section" id="section1">
      <div class="video-box">
        <img class="headimage" src="@/assets/images/videoback.png" alt="">
        <video
          autoplay="autoplay"
          muted="muted"
          loop="loop"
          poster
          class="video-bg"
        >
          <source src="@/assets/images/PV6.mp4" type="video/mp4">
        </video>
      </div>
      <div :class="[isDmg?'dmg':'', 'slogan']"></div>

      <template v-if="!_myData.yt">
        <div class="start-btn" v-if="isDmg" @click="showStart = true"></div>
        <div v-if="!isDmg">
          <div class="down-btn google backimgstyle" v-if="_myData.is_can_submit" @click="ggFn" :class="{noResgoogle: !_myData.yuyue, reGoogleback: _myData.yuyue, googleback: !_myData.yuyue}" >
            <a target="_blank" :href="`${_myData.yuyue ? _myData.submit_google : _myData.google }`"></a>
          </div>
          <div class="down-btn ios backimgstyle" v-if="_myData.is_can_submit" :class="{noResios: !_myData.yuyue, reIosback: _myData.yuyue, iosback: !_myData.yuyue}" >
            <span class="iospan" @click="iosFn"></span>
          </div>
        </div>
        <div class="reservation" v-if="_myData.yuyue" @click="goRegister">
        </div>
      </template>
      <template v-else>
        <div class="down-btn2 google backimgstyle" @click="ggFn" :class="{registergg: _myData.yuyue, reGoogleback: _myData.yuyue, googleback: !_myData.yuyue}">
          <a target="_blank" :href="`${_myData.yuyue ? _myData.submit_google : _myData.google }`"></a>
        </div>
        <div class="down-btn2 ios backimgstyle" :class="{registerios: _myData.yuyue, reIosback: _myData.yuyue, iosback: !_myData.yuyue}">
          <span class="iospan" @click="iosFn"></span>
        </div>
        <div class="reservation showbtn" v-if="_myData.yuyue" @click="goRegister">
        </div>
        <div>
          <iframe class="iframe" :class="{topiframe: _myData.yuyue}" :src="_myData.yt" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
        </div>
      </template>
    </div>

    <div
      class="section"
      id="section2"
    >

      <div class="new1-wrap">

        <div class="tw-bg" v-if="!_myData.news || !_myData.news[0]">
          <div class="twBox">
            <a
              class="twitter-timeline"
              data-theme="light"
              data-link-color="#FAB81E"
              :href="twitter"
              >Tweets by AkakuroJP</a
            >
          </div>
          <div @click="twFn(twitter)" class="tw-btn"></div>
        </div>

        <div v-else class="news-box">
          <div class="tw-bg">
            <div class="twBox">
              <a
                class="twitter-timeline"
                data-theme="light"
                data-link-color="#FAB81E"
                :href="twitter"
                >Tweets by AkakuroJP</a
              >
            </div>
            <div @click="twFn(twitter)" class="tw-btn"></div>
          </div>

          <div class="news-wrap">
            <div class="news-channel">
              <span @click="choseChannel(index)" :class="newsActive == index ? 'active' : ''" v-for="(item, index) in _myData.news" :key="index">{{item.name}}</span>
            </div>
            <img @click="jumpNews" class="add" v-lazy="require('@/assets/images/add.png')" alt="">
            <div class="news-list">
              <div @click="jumpDetail(item)" class="news-item" v-for="(item, index) in _myData.news && _myData.news[newsActive].list" :key="index">
                <div class="news-title">{{item.title}}</div>
                <div class="date">{{item.publish_time}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div
      class="section"
      id="section3"
    ></div>

    <div
      class="section"
      id="section4"
    >
      <div class="round-wrap">
        <!-- <div class="dot-box">
          <div class="up" @click="revolve(activeIndex - 1)" v-lazy:background-image="{ src: require('@/assets/images/up.png') }"></div>
          <div class="dot-bg" v-lazy:background-image="{ src: require('@/assets/images/dotbg.png') }"></div>
          <div class="down" @click="revolve(activeIndex + 1)" v-lazy:background-image="{ src: require('@/assets/images/down.png') }"></div>
        </div> -->
        <div id="round" class="round-box">
          <div
            :class="[
              'head-box',
              hideIndex == index ? 'hide' : '',
              activeIndex == index + 1 ? 'active' : '',
            ]"
            :style="{
              left: `${r_width/2 * Math.cos(Math.PI / 180 * (360 / heroList.length * index)) + (r_width/2 - hr_width/2)}px`,
              top: `${r_width/2 * Math.sin(Math.PI / 180 * (360 / heroList.length * index)) + (r_width/2 - hr_width/2)}px`
            }"
            v-for="(item, index) in heroList"
            :key="index"
            :data-id="index + 1"
            @click="revolve(index + 1)"
          >
            <img
              class="head-icon"
              :src="require(`@/assets/images/hero/${item.id}tx.png`)"
              alt=""
            />
            <div class="head-mask" v-show="activeIndex != index + 1"></div>
          </div>
        </div>
      </div>
      <img class="hero-imgback" :src="require(`@/assets/images/hero/${desImg}.png`)" @load="loadFn(desImg)" alt="" :class="['hero-des']">

      <span class="voice-icon" v-if="showVoice" @click="openAudio">
        <i class="hevoice backimgstyle" :style="{backgroundImage: 'url(' + require('@/assets/images/horn_pc'+hersicon+'.png') + ')'}"></i>
      </span>

      <div class="prev-up" @click="revolve(activeIndex - 1)" v-lazy:background-image="{ src: require('@/assets/images/prev.png') }"></div>
      <div class="next-down" @click="revolve(activeIndex + 1)" v-lazy:background-image="{ src: require('@/assets/images/next.png') }"></div>

      <audio id="heroaudio" class="voice-audio" controls height="2" width="2">
        <source :src="require(`@/assets/audio/hero/${desImg}.mp3`)" type="audio/mp3">
      </audio>
    </div>

    <div
      class="section"
      id="section5"
    >
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in _myData.bannerList"
            :key="index"
          >
            <img :src="item" alt="" />
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

    <div
      :class="[isDmg?'dmg':'','section']"
      id="section6"
      v-if="_myData.showFaq"
    >
      <div :class="[isDmg?'dmg':'','faq-box']">
        <div class="text-box" v-for="(item, index) in _myData.faq" :key="index">
          <div class="text-title">
            <div class="q">Q{{ index + 1 }}</div>
            <div class="question">{{ item.title }}</div>
          </div>
          <div class="answer">{{ item.content }}</div>
        </div>
        <div @click="jumpFaq"  class="faq-btn backimgstyle"></div>

      </div>
    </div>
    <img v-if="_myData.floatBanner && isDmg && _myData.floatBanner.is_open === 'yes'" class="floatBanner" @click="toNews" :src="_myData.floatBanner.src" alt="">
    <Pbottom v-if="!isDmg"></Pbottom>
    <BottomCom v-if="isDmg"></BottomCom>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { TweenMax } from "gsap";
import { clearParams } from "@/util/index"
import Pheader from "@/components/pc/Head";
import Pbottom from "@/components/pc/Bottom1";
import BottomCom from "@/components/BottomCom";
import DialogBs from "@/components/DialogBs";
import StartModal from "@/components/StartModal";
import { isPc } from "@/util/index"

export default {
  components: {
    Pheader,
    Pbottom,
    BottomCom,
    StartModal,
    DialogBs
  },
  computed: {
    ...mapState(["_myData"]),
    isDmg() {
      return this.$route.name === 'dmg'
    },
    roundDom() {
      return document.querySelector("#round");
    },
    headDom() {
      return document.querySelectorAll(".head-box");
    },
    hideIndex() {
      return this.defaultRoundIndex + 20;
    },
    desImg () {
      return this.heroList[this.activeIndex - 1].id
    },
    // h_ () {
    //   return window.innerHeight
    // },
    sectionHeight () {
      return 1080 - window.innerHeight
    }
  },
  created () {
    setTimeout(() => {
      let script = document.createElement("script")
      script.type = "text/javascript";
      script.src = "https://platform.twitter.com/widgets.js"
      document.getElementsByTagName("head")[0].appendChild(script);
    }, 1000);
  },
  data() {
    return {
      showStart: false,
      loadVideo: false,
      timeout: null,
      defaultRoundIndex: 1,
      activeIndex: 1,
      videoList: [],
      heroList: [
        {
          id: "ll",
          name: "ライラ",
          audio: "日高 里菜",
          des:
            "銃器の名門に生まれたライラは、小さい頃から活発で明るく、前向きで冒険心に溢れる女の子であった。最も得意とするマジックガンの技術で学者の城の代表となり、黎明の地の平和を守る使者として大陸中を冒険するのが夢である。鍛錬に励み続けたライラは、十六歳となりようやく英雄への道を歩き始めた。",
        },
        {
          id: "tgre",
          name: "ティグラル",
          audio: "杉田 智和",
          des:
            "モクネア帝国の騎士団長を務めている。自らを厳しく律する正義感に満ちた性格の持ち主である。幼い頃から光の王の信仰に傾倒していた彼は、黎明の地での帝国の地位と栄光を守るために戦い続けている。勇敢さと大胆さを具現したとも言える存在であり、全帝国の誇りである「曙光の戦神」の異名を持つ。",
        },
        {
          id: "lfe",
          name: "ラファエル",
          audio: "植田 佳奈",
          des:
            "治癒の魔法を操る天使。彼女が降臨すると、一切の苦痛は消え、あらゆる傷が癒やされ、悪は消え去ると言われている。光の王の使節として黎明の地に降り立ったラファエルは、大陸の平穏を取り戻すため自身の治癒の魔法を役立てようと考えている。",
        },
        {
          id: "ydl",
          name: "エウドラ",
          audio: "田中 理惠",
          des:
            "学生の頃より、エウドラの雷を操る才能は多くの魔導士の想像を絶するものであった。軽く勉強した程度で教師から教われる魔法の知識は全て吸収してしまった。物足りなさを感じたエウドラはモクネアへ旅立ち、そこで新たな試練に巡り合えることを期待した。",
        },
        {
          id: "xm",
          name: "星夢",
          audio: "田村ゆかり",
          des:
            "星夢が何処から来たのかを知るものはおらず、おそらく彼女自身もそうである。考え得る唯一の可能性は、彼女が黙示録と共にこの世に顕現し、何らかの宿命を負って、全てが終わる時を待っているということだ。秩序の光と混沌の闇に囚われた彼女は、紡がれる夢の中で目覚めの日を待つ。",
        },
        {
          id: "akx",
          name: "アーカーシャ",
          audio: "苍井 翔太",
          des:
            "不穏の時代、モクネア帝国の皇帝であるセリウス四世の幕僚として、政治の舞台で活躍していた。今も昔も変わらず、首都ライトボーンにおいて最も狂った術師であり学者でもある。この伝説の術師と同じ名で知られる彼の書物、この世のあらゆる事象が予言されていると言われるそれは「アカシックレコード」と呼ばれている。",
        },
        {
          id: "lsl",
          name: "ラズリー",
          audio: "豊崎 愛生",
          des:
            "ラズリーの一族は、百年余りエスク族の影の護衛として務めてきた。とある護衛任務の中で殉職したラズリーの父は、一族の意志を宿した黒いマスケット銃を遺し、長女であるラズリーが受け継いだ。弟のハーリーを守るため、ラズリーは自身の感情を殺し、誰もが恐れるスナイパーとなった。",
        },
        {
          id: "llt",
          name: "ロイン",
          audio: "佐倉 綾音",
          des:
            "戦乱の中でルーニー博士に命を救われたロインは、彼と学者の城に恩返しをするために学者の城の警備隊に入隊し、城の安全と平和を守っている。エネルギーコアの力を得た彼女は、巨大な機械のハンマーをも思い通りに扱える程の力を持つ。",
        },
        {
          id: "als",
          name: "アリス",
          audio: "日笠 陽子",
          des:
            "ブラッドデーモンは、他の生命エネルギーを吸い取ることで生きる種族である。彼らは長い間、銀月の森に住むムーンエルフを食料としていた。オーク族を奴隷とした後も、野心と欲望を肥大化させるブラッドデーモンの女王アリスは、アビスの勢力の協力を得て、銀月の森への全面攻勢を目論む。",
        },
        {
          id: "bz",
          name: "半蔵",
          audio: "林 大地",
          des:
            "風魔半蔵は、究極の力を求める影宗百年来の天才忍者である。新たな「影」となった後、初代赤影の心魔を取り込み、自身の血肉を天魔へ差し出した。事が明るみに出ると、彼はかつて天魔を封印した忍具「天魔羽々斬」を奪い、大虐殺を始めた。彼は終わりのない殺戮の道を歩み始めたのだ。",
        },
        {
          id: "hh",
          name: "花火",
          audio: "上田 丽奈",
          des:
            "花火は幼い頃より赤宗の宗主から指導を受けていた。人並みを遥かに超えた才能を持つ彼女に対抗できる同年代の忍者は、隼という影宗の少年と出会うまではいなかった。隼が「影」になったと聞いた彼女は、自身も「赤」の名を受け継ぐ決心を固めた。彼女は禁断の地から禁忌の刃「彼岸花」を持ち出し、隼の前で半蔵を殺すことを誓った。",
        },
        {
          id: "mets",
          name: "マーティス",
          audio: "藤沼 建人",
          des:
            "修羅界の中央に「三千界」と呼ばれる秘境が存在する。その秘境には三千世界があり、そこに入った者はそれぞれの心魔業障と向き合い、それを倒せるまで次の世界に進むことはできない。勝利と殺戮を求め続けたマーティスは初めて三千世界を突破した阿修羅となり、無数の眷属を率いる「阿修羅の王」と呼ばれるようになった。",
        },
        {
          id: 'fes'
        }
      ],
      deg: 0,
      newsActive: 0,
      twitter: 'https://twitter.com/AkakuroJP',

      hersicon: 2,
      voiceInterval: null,

      checkImg: '',
      showVoice: false,
      imgLoadarr: [],
      checkNum: 0,

      r_width: null,
      hr_width: null,

      mySwiper: null,

    };
  },
  mounted() {
    this.vvloadFn()

    // 计算转盘的位置
    this.setRoundFn();
    window.addEventListener("resize", ()=>{
      this.setRoundFn();
    }, false);

    const inter = setInterval(() => {
      if (this._myData.bannerList) {
        this.initSwiper();
        clearInterval(inter);
      }
    }, 200);

    if (this.$route.query.index != undefined) {
      // window.scrollTo({
      //   top: this.$route.query.index * 1080 - this.sectionHeight,
      // });
      clearParams()
    }

  },
  methods: {

    setRoundFn() {
      const oRoundWrap = document.querySelector('.round-wrap');
      const oHeadBox = document.querySelector('.head-box');
      this.r_width = this.getDomType(oRoundWrap, 'width');
      this.hr_width = this.getDomType(oHeadBox, 'width');
    },

    twFn(url) {
      if (url) {
        window.open(url);
      }
    },

    ggFn () {
      //
    },

    // ios按钮跳转
    iosFn () {
      const url = this._myData.yuyue ? this._myData.submit_ios : this._myData.ios;
      if (url) {
        window.open(url);
      } else {
        layer.open({
          content: 'まだ公開されていません。しばらくお待ちください。',
          time: 2,
          skin: 'msg'
        })
      }
    },

    toNews() {
      const newId = this._myData.floatBanner.newId || '';
      if(newId) {
        const url = `${window.location.origin}/detail?id=${newId}&origin=${this.$route.name}`;
        window.open(url);
      }
    },
    jumpNews () {
      this.$store.dispatch('setChannelId', this._myData.news[0].id)
      this.$router.push({name: 'news'})
    },
    jumpDetail (item) {
      const id = item.id;
      const url = `${window.location.origin}/detail?id=${id}&origin=${this.$route.name}`;
      window.open(url);

      // this.$router.push({name: 'detail', query: {id}})
    },
    choseChannel (index) {
      this.newsActive = index
    },
    revolve(realIndex) {
      this.showVoice = false;
      this.checkNum = 0;
      const oHeroimgback = document.querySelector('.hero-imgback');
      oHeroimgback.src = '';

      const vnum = JSON.parse(JSON.stringify(this.activeIndex))
      if (vnum != realIndex) {
        const audio = document.getElementById("heroaudio");
        if (audio && !audio.paused) {
          audio.pause();
          this.hersicon = 2;
          window.clearInterval(this.voiceInterval);
        }
      }

      const {heroList} = this
      const len = (heroList || []).length
      const degStep = 360 / (len || 1)
      this.activeIndex = realIndex;
      if (this.activeIndex <= 0) {
        this.activeIndex += len
      }
      if (this.activeIndex > len) {
        this.activeIndex = 1
      }
      let index = 0;
      index = realIndex;
      if (index > len / 2) {
        index -= len;
      }
      if (this.defaultRoundIndex <= len / 2 && this.defaultRoundIndex >= len / 3 && index < 0) {
        this.deg += (len - this.defaultRoundIndex + index)* -degStep
      } else if (this.defaultRoundIndex <= -len / 4 && this.defaultRoundIndex >= -len / 2 && index > 0) {
        this.deg += (len + this.defaultRoundIndex - index)* degStep
      } else {
        this.deg += (this.defaultRoundIndex - index) * degStep;
      }
      this.defaultRoundIndex = index;
      TweenMax.to(this.roundDom, 0.8, {
        rotation: this.deg,
      });
      TweenMax.to(this.headDom, 0.8, {
        rotation: -this.deg,
        scale: 1,
      });
      setTimeout(() => {
        TweenMax.to(document.querySelector("#round .active"), 0.8, {
          scale: 1.3,
        });
      }, 50);
    },
    initSwiper() {
      this.mySwiper = new Swiper(".swiper-container", {
        loop: true,
        effect: "coverflow",
        slidesPerView: 1.5,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 40,
          depth: 500,
          modifier: 1,
          slideShadows: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    jumpFaq() {
      const url = `${window.location.origin}/detail?id=faq&origin=${this.$route.name}`;
      window.open(url);
    },
    goRegister() {
      const url = window.location.origin + '/register'
      window.open(url);
    },

    // 打开音频
    openAudio () {
      const audio = document.getElementById("heroaudio");
      if (audio.paused) {
        audio.load()
        audio.play();
      }
      audio.addEventListener("playing", ()=>{
        this.hersicon = 2;
        this.intervalFn();
      });
      audio.addEventListener("pause", ()=>{
        this.hersicon = 2;
        window.clearInterval(this.voiceInterval);
      });
    },

    intervalFn() {
      if (this.voiceInterval) {
        window.clearInterval(this.voiceInterval);
      }
      this.voiceInterval = setInterval(()=>{
        this.hersicon = this.hersicon == 1 ? 2 : 1;
      }, 300)
    },

    loadFn () {
      this.showVoice = true;
    },

    getDomType(dom, style) {
      const styles = this.getStyle(dom, style);
      const height = styles.slice(0, styles.length -2);
      return Number(height);
    },
    // 获取样式
    getStyle(el, attr) {
        if (el && el.currentStyle) {
          // IE,OPER
          return el.currentStyle[attr]
        } else {
          // chrome、safari、FireFox
          return window.getComputedStyle(el)[attr]
        }
    },

    vvloadFn () {
      const video = document.querySelector('.video-bg');
      if (video) {
        // video.addEventListener('canplaythrough', ()=>{
        //   this.loadVideo = true;
        // });
        video.addEventListener("click",()=>{
          video.muted=false;
        },false);
      }

    },


  },
};
</script>

<style lang="scss" scope>
@import "@/assets/scss/views/home.scss";
</style>
